import classNames from 'classnames';
import Style from '../VerificationCodeBrick/VerificationCodeBrick.module.less';
import FJNav from '../common/FJNav/FJNav';
import FJLocalStore from '../../store/FJLocalStore';
import FJInput from '../common/FJInput/FJInput';
import FJErrTip from '../common/FJErrTip/FJErrTip';
import FJButton from '../common/FJButton/FJButton';

import { useCallback, useEffect, useRef, useState } from 'react';
import FJAction from '../../action/FJAction';
import { useDispatch, useSelector } from 'react-redux';
import FJUtil from '../../util/FJUtil';
import FJLoading from '../common/FJLoading/FJLoading';
import loadingIcon from '../../assets/icon/loading_one.gif';

export default function NewUserVerifyEmailCode(props) {
    const dispatch = useDispatch();
    let { stepChange, popupType, active } = props;

    const [code, setCode] = useState('');
    const [errTip, setErrTip] = useState(null);
    const [load, setLoad] = useState(false);

    let inputRef = useRef();

    const { time, countShow, confirmEmail } = useSelector(store => {
        return {
            time: store.mainStore.time,
            confirmEmail: store.mainStore.confirmEmail,
            countShow: store.mainStore.verificationTimeShow,
        };
    });

    let _navClick = () => {
        stepChange('default');
    };

    let _onChange = value => {
        _clean();
        setCode(value);
    };

    let formatValue = value => {
        const matches = value.match(/\d+/g); // 使用 match() 函数进行匹配
        return matches ? matches.join('') : '';
    };

    let _clean = () => {
        inputRef.current.setInit();
        setErrTip(null);
    };

    // 格式验证
    let _formatCheck = useCallback(() => {
        let res = true;
        if (code.length === 0) {
            res = false;
            inputRef.current.setErrorMessage(FJLocalStore._('enter-verification-here'));
            return res;
        } else if (code.length > 0 && code.length < 6) {
            res = false;
            inputRef.current.setErrorMessage(FJLocalStore._('enter-verification-length'));
            return res;
        } else {
            inputRef.current.setInit();
        }
        return res;
    }, [code]);

    // 检验 验证码
    let _codeConfirm = (code, callback) => {
        dispatch(FJAction.confirmCode(code, callback));
    };

    let _sendClick = useCallback(() => {
        let result = _formatCheck();
        if (!result) {
            return;
        }
        setLoad(true);
        const obj = {
            code,
            type: 1,
        };
        _codeConfirm(obj, option => {
            setLoad(false);
            if (option.networkFail) {
                setErrTip(option.errTip);
            } else if (option.result === true) {
                setErrTip(null);
            } else {
                setErrTip(option.errTip);
            }
        });
    }, [code, _formatCheck, _codeConfirm]);

    let _resendCode = () => {
        const _timeCount = returnData => {
            if (returnData.code !== 200) {
                dispatch(FJAction.changeVerificationTimeShow(false));
                FJUtil.countDown('verification', 0, () => {});
                return;
            }

            FJUtil.countDown('verification', 60, value => {
                if (Boolean(value)) {
                    dispatch(FJAction.setIntervalTime(value));
                } else {
                    dispatch(FJAction.changeVerificationTimeShow(false));
                    dispatch(FJAction.setIntervalTime(null));
                }
            })();
        };

        if (countShow === false) {
            dispatch(FJAction.changeVerificationTimeShow(true));
            // _timeCount();
            const obj = {
                email: confirmEmail,
                type: 1,
                is_resend: 1,
                code_language: FJLocalStore.currentTag(),
            };
            dispatch(FJAction.resendCode(obj, _timeCount));
        }
    };

    let _enterSendCode = useCallback(
        e => {
            if (e.keyCode === 13) {
                _sendClick();
            }
        },
        [_sendClick],
    );

    useEffect(() => {
        FJUtil.addEvent(window, 'keydown', _enterSendCode);
        return () => {
            FJUtil.removeEvent(window, 'keydown', _enterSendCode);
        };
    }, [time, _enterSendCode, countShow]);
    return (
        <div
            className={classNames(Style.code_box, { [Style.code_box_show]: active, [Style.code_box_popup]: popupType })}
        >
            <FJNav title={FJLocalStore._('verify-email-code')} onClick={_navClick} popupType={popupType} />
            <p
                className={Style.curTip}
                dangerouslySetInnerHTML={{
                    __html: FJLocalStore._('edit-code-to-continue').replace('xxx', confirmEmail),
                }}
            />
            {/* password输入框为解决谷歌自动填充  影响编辑页和模板页的输入框 其余组件一样 */}
            <input type='password' style={{ height: '0px' }} />
            <FJInput
                value={code}
                onChange={_onChange}
                formatValue={formatValue}
                valueChangeTime='onchange'
                maxInputLength={6}
                label={FJLocalStore._('verification-code')}
                placeholder={FJLocalStore._('enter-verification-here')}
                type='text'
                className={Style.inputMargin}
                inputClassName={Style.input}
                ref={inputRef}
                popupType={popupType}
                // hasRightIcon
            />
            <FJErrTip errTip={errTip} />
            <FJButton
                text={FJLocalStore._('verify-email-code-continue')}
                small={popupType}
                className={Style.submit_btn}
                isLoading={load}
                onClick={_sendClick}
            />
            {countShow ? (
                <div className={Style.resend_time}>
                    {!Boolean(time) ? (
                        <FJLoading src={loadingIcon} loading={true} />
                    ) : (
                        FJLocalStore._('resend-code-after').replace('xxx', time)
                    )}
                </div>
            ) : (
                <p className={Style.resend_code} onClick={_resendCode}>
                    {FJLocalStore._('resend-code')}
                </p>
            )}
        </div>
    );
}
